<template>
  <div style="background-color:white !important;">

    <Slider></Slider>

    <div class="container mt-5" v-if="show">
      <!-- row-1 -->
      <div class="row pb-5 pt-5" v-scrollanimation>
        <div class="col-lg-5 mx-auto">
          <img
            src="/src/assets/photos/icerik-1.png"
            class="img-fluid"
            width="450"
            alt="Ayancık Adak"
          />
        </div>
        <div class="col-lg-7 mt-5" v-for="(item,i) in yazi.slice(0, 1)" :key="i">
          <h2>{{ item.baslik }}</h2>
          <hr />
          <p>
           &nbsp &nbsp &nbsp&nbsp &nbsp  {{ item.icerik }}
          </p>
          
        </div>
      </div>
      <!-- row-2 -->
      <div
        class="row pb-5 pt-5"
        v-for="(item,i) in yazi.slice(1, 2)"
        :key="i"
        v-scrollanimation
      >
        <div class="col-lg-7 ">
          <h2>{{ item.baslik }}</h2>
          <hr />
          <p>

           &nbsp &nbsp &nbsp&nbsp &nbsp  {{ item.icerik }}
          </p>
        
        </div>

        <div class="col-lg-5 mx-auto mt-5">
          <img
            src="/src/assets/photos/icerik-2.png"
            class="img-fluid "
            width="450"
            alt="Ayancık Adak"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "../components/Slider";
export default {
  data() {
    return {
      yazi: [
        {baslik:"Profesyonel ve Temiz Kesim",icerik:" İslami Usullere Göre Temiz Bir Şekilde Adaklığınızı veya Kurbanlığınızı  Kesip ve Parçalayıp Sizlere Sunuyoruz. Üstelik Kesim Ücretsizdir! (Hayvan Alımı Olmadan Sadece Kesim Yapılacaksa Ücretlidir!)"},
        {baslik:"Hesaplı ve Kaliteli Ürün",icerik:"Her Bütçeye , Her Müşteriye Uygun Şekilde Hayvanlarımız Mevcuttur. 1980'den beri Sizlere Kaliteli, Temiz ve Ucuz Hizmet Vermek Önceliğimizdir! Memnuniyetiniz Memnuniyetimizdir!"},
        ],
      show : false
    };
  },
  methods:{
    
  },
  components: {
    Slider
  },
  created(){
    setTimeout(()=>{
      this.show = true
    },100)
  }
};
</script>

<style scoped>
img {
  border-radius: 10px;
  -webkit-box-shadow: -1px 16px 30px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 16px 30px 0px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 16px 30px 0px rgba(0, 0, 0, 0.75);
}
.btn-outline-success {
  border-color: #438a5e !important;
}
.btn-outline-success:hover {
  background-color: #438a5e !important;
}

.before-enter {
  opacity: 0;
  transform: scale(0.6);
  transition: all 1s cubic-bezier(0.42, 0.01, 0.51, 1.49);
}
.enter {
  opacity: 1;
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue